import { useEffect } from "react";

/**
 * Aviso corto en la parte superior de una pantalla, para confirmar que
 * algo se guardó. Se cierra solo a los cuatro segundos.
 */
const Aviso = ({ mensaje, onCerrar, duracion = 4000 }) => {
  useEffect(() => {
    if (!mensaje) return;
    const temporizador = setTimeout(onCerrar, duracion);
    return () => clearTimeout(temporizador);
  }, [mensaje, onCerrar, duracion]);

  if (!mensaje) return null;

  return (
    <div className="aviso" role="status">
      <span>{mensaje}</span>
      <button type="button" className="aviso-cerrar" onClick={onCerrar} aria-label="Cerrar aviso">
        ×
      </button>
    </div>
  );
};

export default Aviso;
